import cache from '@/services/cache-service';
import settingsApi from '@/services/resources/settingsApi';

function flushCache() {
    return cache.remove('settings.all');
}

function getAll() {
    return cache.get('settings.all', () => settingsApi.find());
}

function saveSplitOrder(value) {
    flushCache();
    return settingsApi.saveSplitOrder(value);
}

function saveSplitOrderOptionsSettings(value) {
    flushCache();
    return settingsApi.saveSplitOrderOptionsSettings(value);
}

function saveLotExpirationAction(action) {
    flushCache();
    return settingsApi.saveLotExpirationAction(action);
}

function saveProductDeclareValueOptions(action) {
    flushCache();
    return settingsApi.saveProductDeclareValueOptions(action);
}

function saveReturnInstructions(value) {
    flushCache();
    return settingsApi.saveReturnsInstructions(value);
}

function saveShippingAddress(value) {
    flushCache();
    return settingsApi.saveShippingAddress(value);
}

function saveShipperContactInformation(value) {
    flushCache();
    return settingsApi.saveShipperContactInformation(value);
}

function hasRecentInternationalOrders(startDate, endDate) {
    flushCache();
    return settingsApi.hasRecentInternationalOrders(startDate, endDate);
}

function saveStandardPackingSlip(enabled) {
    flushCache();
    return settingsApi.saveStandardPackingSlip(enabled);
}

export default {
    getAll,
    flushCache,
    saveSplitOrder,
    saveSplitOrderOptionsSettings,
    saveLotExpirationAction,
    saveProductDeclareValueOptions,
    saveShippingAddress,
    saveShipperContactInformation,
    saveReturnInstructions,
    hasRecentInternationalOrders,
    saveStandardPackingSlip,
};
